// How-to-play steps, shared by the /how-to-play page and the prerender script
// (which injects HowTo JSON-LD into the static HTML for non-JS crawlers).
export const steps = [
  {
    title: 'Create your club',
    text: 'Register for free and your club is created instantly with a starting squad, a stadium and a transfer budget. Pick your club name and colors - this is the identity you will take to the top.'
  },
  {
    title: 'Get to know your squad',
    text: 'Every player has a position (Goalkeeper, Defender, Midfielder or Forward), an overall rating and individual attributes. Review your squad to find your strongest starting eleven and spot the positions that need reinforcement.'
  },
  {
    title: 'Set your lineup and tactics',
    text: 'Choose a formation, pick your starting eleven and set your team mentality. Assign free kick, corner and penalty takers in the set pieces screen. Tactics feed directly into the match engine, so match them to your squad\'s strengths.'
  },
  {
    title: 'Challenge other managers',
    text: 'Send a random challenge to face a manager from anywhere in the world, or challenge a friend directly. Once accepted, the match is scheduled and simulated by the live match engine.'
  },
  {
    title: 'Watch your match live',
    text: 'Follow the action minute by minute: goals, assists, cards, injuries and momentum swings. Match results update your coach record and your position on the global leaderboard.'
  },
  {
    title: 'Trade on the transfer market',
    text: 'Buy players listed by other managers and sell your own to fund upgrades. Smart trading beats big spending - scout for undervalued players and flip them for profit.'
  },
  {
    title: 'Train players and use boosts',
    text: 'Develop your players through training to raise their attributes over time. For big matches, activate stat boosts from booster packs to give your team a temporary edge.'
  },
  {
    title: 'Claim rewards and climb the rankings',
    text: 'Log in daily to claim your bonus coins, keep winning to climb the coach leaderboard, and aim for the top of the goals, assists and rating charts with your star players.'
  }
];

export default steps;
